import styled from "styled-components";

export const Select = styled.select<{ hasError?: boolean }>`
  width: 100%;
  padding: 0.75rem;
  background-color: ${({ theme }) => theme.colors.neutral};
  border: 1px solid ${({ theme, hasError }) => hasError ? theme.colors.red800 : theme.colors.neutral100};
  border-radius: 4px;
  font-size: 18px;
  transition: border-color 0.2s;

  &:focus {
    outline: none;
    border-color: ${({ theme, hasError }) => hasError ? theme.colors.red800 : theme.colors.primary600};
  }

  &::placeholder {
    color: ${({ theme }) => theme.colors.neutral500};
  }
`;

export const ErrorMessage = styled.span`
  display: flex;
  align-items: end;
  gap: 0.3rem;
  color: ${({ theme }) => theme.colors.red800};
  font-size: 12px;
  margin-top: 0.5rem;
`;